//
// "Dummy" disabled LogEntry to be returned by disabled logging functions
//
var disabledLogEntry;

/* eslint-disable no-empty-function */
function DisabledLogEntry () {
}

DisabledLogEntry.prototype = {
    write: function () {},
    error: function () {},
    startNew: function () {
        return disabledLogEntry;
    },
    setAttribute: function () {},
    setReturn: function () {}
};
/* eslint-enable no-empty-function */

// Create a single global instance
disabledLogEntry = new DisabledLogEntry();
